module.exports = __webpack_public_path__ + "media/oauth/google-9fe90a17.svg";